import { render, staticRenderFns } from "./comp.vue?vue&type=template&id=9f009d20&scoped=true&"
import script from "./comp.vue?vue&type=script&lang=js&"
export * from "./comp.vue?vue&type=script&lang=js&"
import style0 from "./comp.vue?vue&type=style&index=0&id=9f009d20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f009d20",
  null
  
)

export default component.exports